exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget[data-v-27845d3a] {\n  background-color: #fff;\n  border: solid 1px #8f8f8f;\n}\n.icon[data-v-27845d3a] {\n  background-color: #80b466;\n  min-width: 3rem;\n  max-width: 3rem;\n  min-height: 3rem;\n  max-height: 3rem;\n}", ""]);

// exports
